import React from "react";
import ErrorPage from "../../Components/errorPage/ErrorPage";

const Unauthorized = () => {
  return (
    <>
      <ErrorPage
        errorCode={401}
        content={"Oops! Looks like you're not Authorized."}
        href={"/login"}
        hrefTag={"login"}
      />
    </>
  );
};

export default Unauthorized;
